import { render, staticRenderFns } from "./PublicTable.vue?vue&type=template&id=41d3e07c"
import script from "./PublicTable.vue?vue&type=script&lang=ts"
export * from "./PublicTable.vue?vue&type=script&lang=ts"
import style0 from "./PublicTable.vue?vue&type=style&index=0&id=41d3e07c&prod&lang=scss&scpoed=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports